// Module
var code = `<!-- blQuote — blog blockquote.
     Data shape: { text: "inline HTML", classStr?: "modifier class" } -->
<blockquote class="{{classStr}}">{{text}}</blockquote>
`;
// Exports
module.exports = code;